// @flow
import React from 'react'
import styled from 'styled-components'
import Spinner from '../../../../components/Spinner'

const Component = styled.div`
  height: 1000px;
`

const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
`

const PropertyLoadingPage = () => (
  <Component>
    <Overlay>
      <Spinner />
    </Overlay>
  </Component>
)

export default PropertyLoadingPage



// WEBPACK FOOTER //
// ./src/views/Property/components/PropertyLoadingPage/index.js